export const getApiBaseUrl = () => {
  const isLocalPreview = typeof window !== 'undefined' && window.location.hostname === 'localhost';
  const isSwaProxyEnabled = import.meta.env.VITE_USE_SWA_PROXY === 'true';

  return import.meta.env.DEV || isLocalPreview || isSwaProxyEnabled
    ? '/api'
    : import.meta.env.VITE_API_URL;
};
